import { useSelector } from "react-redux";
import "./HrPosition.scss";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch.jsx";
import CircularButton, {
  CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import { showToast } from "../../../toastService.js";
import newRequest from "../../../utils/newRequest.js";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Popover,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FiSearch } from "react-icons/fi";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { useEffect, useState } from "react";
import { GridLoader, ScaleLoader } from "react-spinners";
import { fetchJobs, fetchPositions, formatNumber, formatStringToNumberV2, logData } from "../../../utils/genericFunctions.js";
import { customSelectStyles_dark, customSelectStyles_light, muiSelectStyles_dark, muiSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { MdAccountTree, MdAdd, MdClose, MdDelete, MdRefresh, MdSave } from "react-icons/md";
import { VscListTree } from "react-icons/vsc";
import { useTranslation } from "react-i18next";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import { motion } from "framer-motion";
import BimaOrgChart from "../../../components/bimaOrgChart/BimaOrgChart.js";
import { useRef } from "react";
import numeral from "numeral";

const HrPosition = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const [isProcessing, setIsProcessing] = useState(false);


  const jobRef = useRef(null);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [isLoading, setIsLoading] = useState(true);
  const [positions, setPositions] = useState([]);
  const [applicableStatuses, setApplicableStatuses] = useState([]);
  const [selectedPosition, setSelectedPosition] = useState({});

  const [leaveTypes, setLeaveTypes] = useState([]);
  const [selectedLeaveType, setSelectedLeaveType] = useState(null);

  const [jobResponsibilities, setJobResponsibilities] = useState([]);
  const [selectedJobResponsibility, setSelectedJobResponsibility] = useState(null);

  const [jobQualifications, setJobQualifications] = useState([]);
  const [selectedJobQualification, setSelectedJobQualification] = useState(null);

  const [leaveClasses, setLeaveClasses] = useState([]);
  const [selectedLeaveClasse, setSelectedLeaveClasse] = useState(null);

  const [orgHierarchy, setOrgHierarchy] = useState([]);
  const [currentView, setCurrentView] = useState("position");

  const [salaryStucture, setSalaryStucture] = useState([]);
  const [selectedSalaryStucture, setSelectedSalaryStucture] = useState(null);

  const [isPositionDialogOpen, setIsPositionDialogOpen] = useState(false);
  const [positionCode, setPositionCode] = useState("");
  const [positionTitle, setPositionTitle] = useState("");

  const [responsibilitiesPage, setResponsibilitiesPage] = useState(0);
  const [qualificationsPage, setQualificationsPage] = useState(0);
  const [rowsPerPageResponsibilities, setRowsPerPageResponsibilities] = useState(5);
  const [rowsPerPageQualifications, setRowsPerPageQualifications] = useState(5);
  const [detailsPerPage, setDetailsPerPage] = useState(5);
  const [selectedResponsibility, setSelectedResponsibility] = useState(null);
  const [selectedQualification, setSelectedQualification] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchLeaveTypes, setSearchLeaveTypes] = useState("");
  const [currencyAction, setCurrencyAction] = useState("");
  const [isCodeDialogOpened, setIsCodeDialogOpened] = useState(false);
  const [posCode, setPosCode] = useState(null);
  const [posTitle, setPosTitle] = useState(null);
  const [posStatus, setPosStatus] = useState({
    value: "New",
    label: "New"
  });
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [currentPage, setCurrentPage] = useState(0);

  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    action_invoked: "",
  });


  const [anchorEl, setAnchorEl] = useState(null);
  const popoverOpen = Boolean(anchorEl);
  const id = popoverOpen ? 'simple-popover' : undefined;

  const resetAction = () => {
    setPositionCode("");
    setPositionTitle("");
  };

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 8));
    setCurrentPage(0);
  };


  const fetchSavedPositions = async () => {
    try {
      const res = await newRequest.post("/hrPosition/findAll", {
        pos_status: "",
        result_limit: 100
      });
      setPositions(res.data);
      setSelectedPosition(res.data[0]);

      const formattedStructure = res.data[0]?.salary_structure?.map(row => ({
        ...row,
        min_salary: numeral(row?.min_salary).format("0,0.00"),
        max_salary: numeral(row?.max_salary).format("0,0.00"),
      }));
      logData("fetchSavedPositions", formattedStructure);
      setSalaryStucture(formattedStructure);

      // const hierarchy = buildHierarchy(res.data);
      setOrgHierarchy(buildHierarchy(res.data));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const fetchSavedLeaveClasses = async () => {
    try {
      const res = await newRequest.post("/hrLeaveClass/findAll", {
        ac_status: "",
        result_limit: 100
      });
      const options = res.data.map((lc) => ({
        ac_types: lc?.ac_types,
        value: lc?.ac_code,
        label: lc?.ac_status === "Active" ? lc?.ac_title : `${lc?.ac_title} : ${t('notActivated')}`,
        isDisabled: lc?.ac_status !== "Active"
      }));
      setLeaveClasses(options);
    } catch (error) {
      console.error("Error fetching leave classes:", error);
    }
  };

  const definedStatuses = async () => {
    try {
      const options = ["New", "Active", "Under Review", "Closed"]?.map((val) => ({
        value: val,
        label: val,
      }));
      setApplicableStatuses(options);
    } catch (error) {
      console.error("Error fetching defined statuses :", error);
    }
  };


  const onComponentMount = async () => {
    try {
      setIsLoading(true);
      await fetchSavedPositions();
      await fetchSavedLeaveClasses();
      await definedStatuses();
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPosition = async (e) => {
    try {
      setIsProcessing(true);
      const res = await newRequest.get(`/hrPosition/find/${selectedPosition._id}`);
      setSelectedPosition(res.data);
      setIsProcessing(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleSearchPosition = async () => {
    try {
      if (searchTerm.length === 0) {
        setIsProcessing(true);
        const res = await newRequest.post(
          "/hrPosition/search",
          {
            search_input: searchTerm,
            result_limit: 100
          }
        );
        if (res.data) {
          setPositions(res.data);
        }
      }
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsProcessing(false);
    }
  };


  const handleResponsibilitiesChangePage = (event, newPage) => {
    setResponsibilitiesPage(newPage);
  };

  const handleResponsibilitiesChangeRowsPerPage = (event) => {
    setRowsPerPageResponsibilities(parseInt(event.target.value, 5));
    setResponsibilitiesPage(0);
  };

  const filteredResponsibilitiesData = jobResponsibilities;
  const slicedResponsibilitiesData = filteredResponsibilitiesData.slice(
    responsibilitiesPage * detailsPerPage,
    responsibilitiesPage * detailsPerPage + detailsPerPage
  );

  const filteredQualificationsData = jobQualifications;
  const slicedQualificationsData = filteredQualificationsData.slice(
    qualificationsPage * detailsPerPage,
    qualificationsPage * detailsPerPage + detailsPerPage
  );

  const handleQualificationsChangeRowsPerPage = (event) => {
    setRowsPerPageQualifications(parseInt(event.target.value, 5));
    setQualificationsPage(0);
  };

  const handleQualificationsChangePage = (event, newPage) => {
    setQualificationsPage(newPage);
  };

  const filteredPositions = positions?.filter(
    (item) =>
      item?.pos_code?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      item?.pos_title?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const filteredALeaveTypes = leaveTypes?.filter(
    (item) =>
      item?.leave_code?.toLowerCase().includes(searchLeaveTypes?.toLowerCase()) ||
      item?.leave_name_xx?.toLowerCase().includes(searchLeaveTypes?.toLowerCase())
  );


  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteLimit") {


      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };


  const handlePositionClassData = (name, value, rowId) => {
    setSelectedPosition(prev => ({
      ...prev,
      [name]: value,
      changed_xx: "Y"
    }));

    // Update list
    setPositions(prev => prev.map(item => item._id === rowId ? { ...item, [name]: value, changed_xx: "Y", salary_structure: salaryStucture } : item));

    // NEW: Refresh leave types when leave class changes
    if (name === "pos_ac_code") {
      const leaveClass = leaveClasses.find(l => l.value === value);
      setLeaveTypes(leaveClass?.ac_types || []);
    }
  };

  const saveRecord = async () => {
    try {
      setIsProcessing(true);

      // ============================
      // 1. VALIDATION
      // ============================
      const errors = [];

      salaryStucture.forEach((row, idx) => {
        const min = formatStringToNumberV2(row?.min_salary, 2);
        const max = formatStringToNumberV2(row?.max_salary, 2);

        // `Row ${idx + 1} (${row.grade_code}): Min salary ${numeral(row?.min_salary).format("0,0.00")} cannot be greater than Max salary ${numeral(row?.max_salary).format("0,0.00")}</br></br>`
        if (min > max) {
          errors.push(
            `Grade (${row?.grade_code}): Min salary ${numeral(row?.min_salary).format("0,0.00")} cannot be greater than Max salary ${numeral(row?.max_salary).format("0,0.00")}</br></br>`
          );
        }
      });

      if (errors.length > 0) {
        const errorMessage = errors.join("\n");

        setNotifyDialogTitle("Note!");
        setNotifyDialogText(errorMessage);
        setIsNotifyDialogOpen(true);

        setIsProcessing(false);
        return; // stop save
      }

      // ============================
      // 2. BUILD FORMATTED STRUCTURE
      // ============================
      const formattedStructure = salaryStucture.map(row => ({
        grade_code: row?.grade_code,
        grade_title: row?.grade_title,
        min_salary: formatStringToNumberV2(row?.min_salary, 2),
        max_salary: formatStringToNumberV2(row?.max_salary, 2),
        steps: []
      }));

      // ============================
      // 3. API CALL
      // ============================
      await newRequest.put(`/hrPosition/upd/${selectedPosition._id}`, {
        pos_code: selectedPosition.pos_code,
        pos_title: selectedPosition.pos_title,
        pos_status: selectedPosition.pos_status,
        pos_job_code: selectedPosition?.job_xx?.job_code,
        pos_ac_code: selectedPosition.pos_ac_code,
        pos_reporting_to: selectedPosition.pos_reporting_to || null,
        salary_structure: formattedStructure
      });

      showToast(t("updated"), "success");
      setIsProcessing(false);

    } catch (err) {
      console.log(err);
      setIsProcessing(false);
    }
  };



  const handleSalaryStructureChange = (e, id, field) => {
    try {
      const updatedData = [...salaryStucture];
      const index = updatedData.findIndex(val => val._id === id);

      if (index !== -1) {
        if (e && e.target) {
          let value = e.target.value;

          // For salary fields: keep raw numeric typing only
          if (["max_salary", "min_salary"].includes(field)) {
            // allow only numbers and commas/dots
            value = value.replace(/[^0-9.]/g, "");
          }

          updatedData[index][field] = value;
        } else if (e && typeof e === "object") {
          updatedData[index][field] = e.value;
        }

        setSalaryStucture(updatedData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSalaryStructureBlur = (id, field) => {
    try {
      const updatedData = [...salaryStucture];
      const index = updatedData.findIndex(smi => smi._id === id);

      if (index !== -1) {
        const value = updatedData[index][field];

        if (["max_salary", "min_salary"].includes(field)) {
          updatedData[index][field] = numeral(value).format("0,0.00");
        }

        updatedData[index]["changed_xx"] = "Y";
        setSalaryStucture(updatedData);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const buildHierarchy = (positions) => {
    const map = {};
    const roots = [];

    positions.forEach(pos => {
      // remove heavy fields
      const {
        leave_class_xx,
        job_xx,
        job_responsibilities,
        job_qualifications,
        updated_by_name_xx,
        updated_by_photo_url_xx,
        createdBy,
        updatedBy,
        createdAt,
        updatedAt,
        ...lightPos
      } = pos;

      map[pos._id] = {
        ...lightPos,
        children: []
      };
    });

    positions.forEach(pos => {
      if (pos.pos_reporting_to) {
        // append child to parent
        map[pos.pos_reporting_to].children.push(map[pos._id]);
      } else {
        // root node (CEO-level)
        roots.push(map[pos._id]);
      }
    });

    return roots;
  };



  useEffect(() => {
    try {
      setPosCode(selectedPosition?.pos_code);
      setPosTitle(selectedPosition?.pos_title);
      setPosStatus({
        value: selectedPosition?.pos_status,
        label: selectedPosition?.pos_status
      });
      setLeaveTypes(selectedPosition?.leave_class_xx?.ac_types || []);
      setJobResponsibilities(selectedPosition?.job_xx?.job_responsibilities || []);
      setJobQualifications(selectedPosition?.job_xx?.job_qualifications || []);
    } catch (error) {
      console.log(error);
    }
  }, [selectedPosition]);


  useEffect(() => {
    onComponentMount();
  }, []);

  return (
    <div className="hr-position">
      {isLoading ? (
        <div className="no-content"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
            <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="hr-position-main-wrapper">
          <div className="hr-position-center-wrapper">
            <div className="center-details">
              <div className="center-navbar">
                <div className="navbar-left">
                  <span className="main-title">{currentView === "position" ? selectedPosition?.pos_title : t('hierachy')}</span>
                </div>
                <div className="navbar-right">
                  {currentView === "position" &&
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="left"
                      endIcon={<MdSave />}
                      onClick={saveRecord}
                    >
                      {t('save')}
                    </CustomLoadingButton>}
                  {currentView === "position" &&
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="none"
                      endIcon={<MdRefresh />}
                      onClick={async () => { await fetchSavedPositions() }}
                    >
                      {t('refresh')}
                    </CustomLoadingButton>}

                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="none"
                    endIcon={currentView === "position" ? <MdAccountTree /> : <VscListTree />}
                    onClick={() => {
                      try {
                        if (currentView === "position") {
                          setCurrentView("hierachy");
                        } else {
                          setCurrentView("position");
                        }
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  >
                    {currentView === "position" ? t('hierachy') : t('position')}
                  </CustomLoadingButton>
                  {<CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="right"
                    endIcon={<MdAdd />}
                    onClick={() => setIsPositionDialogOpen(true)}
                  >
                    {t('newPosition')}
                  </CustomLoadingButton>}
                </div>
              </div>
              {currentView === "position" &&
                <div className="position-details" >
                  <div className="form-details-wrapper">
                    <div className="form-details-left">
                      <div className="input-item-with-label">
                        <label
                          htmlFor="pos_title"
                          style={{ width: "100px" }}
                        >
                          {t('name').toUpperCase()}
                        </label>
                        <input
                          id="pos_title"
                          name="pos_title"
                          type="text"
                          placeholder={t('name').toUpperCase()}
                          value={selectedPosition?.pos_title}
                          onChange={(e) => handlePositionClassData("pos_title", e.target.value, selectedPosition?._id)}
                          className="form-input-item"
                          style={{ width: "400px" }}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="pos_title"
                          style={{ width: "100px" }}
                        >
                          {t('job').toUpperCase()}
                        </label>
                        <AsyncSelect
                          ref={jobRef}
                          id="pos_job_code"
                          name="pos_job_code"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="400px"
                          value={{
                            value: selectedPosition?.job_xx?.job_code,
                            label: selectedPosition?.job_xx?.job_title,
                          }}
                          onChange={option => {
                            handlePositionClassData("pos_job_code", option?.doc_id, selectedPosition._id);
                            setSelectedPosition(prev => ({
                              ...prev,
                              job_xx: {
                                job_code: option?.value,
                                job_title: option?.label
                              }
                            }));
                          }}
                          loadOptions={(inputValue, callback) => fetchJobs(inputValue, callback, [])}
                          isSearchable={true}
                          placeholder={t('jobs')}
                          noOptionsMessage={() => "Type Minimum 2 Letter to Search"} />
                      </div>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="pos_reporting_to"
                          style={{ width: "100px" }}
                        >
                          {t('reportingTo').toUpperCase()}
                        </label>
                        <AsyncSelect
                          id="pos_reporting_to"
                          name="pos_reporting_to"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="400px"
                          value={{
                            doc_id: selectedPosition?.reporting_to_xx?.pos_docid,
                            value: selectedPosition?.reporting_to_xx?.pos_code,
                            label: selectedPosition?.reporting_to_xx?.pos_title,
                          }}
                          onChange={option => {
                            handlePositionClassData("pos_reporting_to", option?.doc_id, selectedPosition._id);
                            setSelectedPosition(prev => ({
                              ...prev,
                              reporting_to_xx: {
                                pos_docid: option?.doc_id,
                                pos_code: option?.value,
                                pos_title: option?.label
                              }
                            }));
                          }}
                          loadOptions={(inputValue, callback) => fetchPositions(inputValue, callback, [])}
                          isSearchable={true}
                          placeholder={t('positions')}
                          noOptionsMessage={() => "Type Minimum 2 Letter to Search"} />
                      </div>
                    </div>
                    <div className="form-details-right">
                      <div className="input-item-with-label">
                        <label
                          htmlFor="pos_code"
                          style={{ width: "100px" }}
                        >
                          {t('code').toUpperCase()}
                        </label>
                        <input
                          id="pos_code"
                          name="pos_code"
                          type="text"
                          placeholder={t('code').toUpperCase()}
                          value={selectedPosition?.pos_code}
                          onChange={(e) => handlePositionClassData("pos_code", e.target.value, selectedPosition?._id)}
                          className="form-input-item"
                          style={{ width: "200px" }}
                          disabled
                        />
                      </div>
                      <div className="input-item-with-label" >
                        <label
                          htmlFor="pos_status"
                          style={{ width: "100px" }}
                        >
                          {t('status').toUpperCase()}
                        </label>
                        <Select
                          id="pos_status"
                          name="pos_status"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="200px"
                          value={applicableStatuses.find(option => option.value === selectedPosition?.pos_status) || null}
                          onChange={selectedOption => handlePositionClassData("pos_status", selectedOption?.value, selectedPosition?._id)}
                          options={applicableStatuses}
                          isSearchable={true}
                          placeholder={t('status')}
                        />
                      </div>
                      <div className="input-item-with-label" >
                        <label
                          htmlFor="pos_ac_code"
                          style={{ width: "100px" }}
                        >
                          {t('absence').toUpperCase()}
                        </label>
                        <Select
                          id="pos_ac_code"
                          name="pos_ac_code"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="250px"
                          value={leaveClasses.find(option => option.value === selectedPosition?.pos_ac_code) || null}
                          onChange={selectedOption => handlePositionClassData("pos_ac_code", selectedOption?.value, selectedPosition?._id)}
                          options={leaveClasses}
                          isSearchable={true}
                          placeholder={t('leaveClasses')}
                        />
                      </div>
                    </div>
                  </div>
                  <ExpandableComponent
                    title={
                      <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", marginBottom: "5px" }}>
                        <span> {t('salaryStructure').toUpperCase()}</span>
                        <CircularButton
                          currentTheme={currentTheme}
                          aria-describedby={id}
                          onClick={(e) => {
                            try {
                              e.stopPropagation();
                              setSalaryStucture((prevData) => {
                                const nextIndex = prevData.length;       // 0-based
                                const nextGrade = String.fromCharCode(65 + nextIndex); // 65 = 'A'

                                return [
                                  ...prevData,
                                  {
                                    _id: crypto.randomUUID(),            // temporary client id
                                    grade_code: nextGrade,               // A, B, C...
                                    grade_title: `Grade ${nextGrade}`,   // Grade A, Grade B...
                                    min_salary: 0,
                                    max_salary: 0,
                                    steps: [],
                                    flag_xx: "new",
                                  },
                                ];
                              });

                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          icon={<MdAdd color="green" />} width={"30px"} height={"30px"} />
                      </div>}
                    subtitle={""}
                    defaultExpanded={salaryStucture?.length > 0}
                  >
                    <div className="salary-structure-wrapper">
                      <div className="salary-structure-left">
                        <div className="table-content">
                          <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                            <Table sx={{ width: "max-content", border: 'none' }}>
                              <TableHead className="tablehead">
                                <TableRow className="tablerow">
                                  <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                    #
                                  </TableCell>
                                  <TableCell className="table-cell left" style={{ maxWidth: "60px" }}>
                                    <span> {t('grade').toUpperCase()}</span>
                                  </TableCell>
                                  <TableCell className="table-cell left" style={{ width: "auto" }}>
                                    <span> {t('title').toUpperCase()}</span>
                                  </TableCell>
                                  <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                    <span> {t('minSalary').toUpperCase()}</span>
                                  </TableCell>
                                  <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                    <span> {t('maxSalary').toUpperCase()}</span>
                                  </TableCell>
                                  <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                                    <span>{t('action').toUpperCase()}</span>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody className="tablebody">
                                {salaryStucture?.map((row, index) => (
                                  <TableRow
                                    key={row._id}
                                    className={`${selectedSalaryStucture?._id === row._id ? "tablerow current" : "tablerow"}`}
                                    onClick={() => setSelectedSalaryStucture(row)}
                                  >
                                    <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                      {index + 1}
                                    </TableCell>
                                    <TableCell className="table-cell left" style={{ maxWidth: "60px" }}>
                                      <div className="input-item-with-label">
                                        <input
                                          id="grade_code"
                                          name="grade_code"
                                          type="text"
                                          value={row?.grade_code}
                                          onChange={(e) => handleSalaryStructureChange(e, row?._id, 'grade_code')}
                                          style={{ width: "100%" }}
                                          className="form-input-item table"
                                        />
                                      </div>
                                    </TableCell>
                                    <TableCell className="table-cell left" style={{ width: "auto" }}>
                                      <div className="input-item-with-label">
                                        <input
                                          id="grade_title"
                                          name="grade_title"
                                          type="text"
                                          value={row?.grade_title}
                                          onChange={(e) => handleSalaryStructureChange(e, row?._id, 'grade_code')}
                                          style={{ width: "100%" }}
                                          className="form-input-item table"
                                        />
                                      </div>
                                    </TableCell>
                                    <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                      <div className="input-item-with-label">
                                        <input
                                          id="min_salary"
                                          name="min_salary"
                                          type="text"
                                          value={row?.min_salary}
                                          onChange={(e) => handleSalaryStructureChange(e, row?._id, 'min_salary')}
                                          onBlur={() => handleSalaryStructureBlur(row?._id, "min_salary")}
                                          style={{ width: "100%", textAlign: "right" }}
                                          className="form-input-item table"
                                        />
                                      </div>
                                    </TableCell>
                                    <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                      <div className="input-item-with-label">
                                        <input
                                          id="max_salary"
                                          name="max_salary"
                                          type="text"
                                          value={row?.max_salary}
                                          onChange={(e) => handleSalaryStructureChange(e, row?._id, 'max_salary')}
                                          onBlur={() => handleSalaryStructureBlur(row?._id, "max_salary")}
                                          style={{ width: "100%", textAlign: "right" }}
                                          className="form-input-item table"
                                        />
                                      </div>
                                    </TableCell>
                                    <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                                      <CircularButton
                                        currentTheme={currentTheme}
                                        onClick={() => setSalaryStucture((prevData) => prevData.filter(doc => doc?._id !== row?._id))}
                                        color="#E53935" icon={<MdDelete/>}
                                        width={"30px"}
                                        height={"30px"} />
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </div>
                      <div className="salary-structure-right">
                        salary-structure-right
                      </div>
                    </div>
                  </ExpandableComponent>
                  <ExpandableComponent
                    title={t('applicableLeaveTypes').toUpperCase()}
                    subtitle={""}
                    defaultExpanded={true}
                  >
                    <>
                      {leaveTypes?.length > rowsPerPage &&
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                            justifyContent: "space-between",
                            alignItems: "center",
                            margin: "10px 0px"
                          }}
                        >
                          <div className="search-input-wrapper" style={{ width: "40%" }}>
                            <FiSearch className="search-input-icon" />
                            <input
                              className="search-input"
                              type="text"
                              placeholder="Search Leave Types..."
                              value={searchLeaveTypes}
                              onChange={(e) => setSearchLeaveTypes(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') handleSearchPosition();
                              }}
                            />
                            {searchLeaveTypes.length > 0 && (
                              <MdClose
                                onClick={async () => setSearchLeaveTypes("")}
                                className="search-input-icon"
                              />
                            )}
                          </div>
                          <TablePagination
                            rowsPerPageOptions={[8]}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleRowsPerPage}
                            component="div"
                            count={leaveTypes?.length}
                            rows={leaveTypes}
                            page={currentPage}
                            onPageChange={handlePageChange}
                          />
                        </div>}
                      {leaveTypes?.length > 0 &&
                        <div className="table-content">
                          <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                            <Table sx={{ width: "max-content", border: 'none' }}>
                              <TableHead className="tablehead">
                                <TableRow className="tablerow">
                                  <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                    #
                                  </TableCell>
                                  <TableCell className="table-cell left" style={{ width: "auto" }}>
                                    <span> {t('title').toUpperCase()}</span>
                                  </TableCell>
                                  <TableCell className="table-cell left" style={{ maxWidth: "250px" }}>
                                    <span> {t('annual').toUpperCase()}</span>
                                  </TableCell>
                                  <TableCell className="table-cell left" style={{ maxWidth: "250px" }}>
                                    <span> {t('carryOver').toUpperCase()}</span>
                                  </TableCell>
                                  <TableCell className="table-cell right" style={{ maxWidth: "50px" }} />
                                </TableRow>
                              </TableHead>
                              <TableBody className="tablebody">
                                {filteredALeaveTypes?.map((row, index) => (
                                  <TableRow
                                    key={row._id}
                                    className={`${selectedLeaveType?._id === row._id ? "tablerow current" : "tablerow"}`}
                                    onClick={() => setSelectedLeaveType(row)}
                                  >
                                    <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                      {currentPage * rowsPerPage + index + 1}
                                    </TableCell>
                                    <TableCell className="table-cell left" style={{ width: "auto" }}>
                                      <h1 className="sub-title">{row?.leave_name_xx}</h1>
                                      <span className="sub-title soft" style={{ fontSize: "10px" }}>{row?.leave_code}</span>
                                    </TableCell>
                                    <TableCell className="table-cell left" style={{ maxWidth: "250px" }}>
                                      <span>{`${row?.annual_days_xx} days | ${row?.annual_hours} hours`}</span>
                                    </TableCell>
                                    <TableCell className="table-cell left" style={{ maxWidth: "250px" }}>
                                      <span>{`Carry Over ${row?.carry_over === "Y" ? "Yes" : "No"} | ${row?.carry_over_hours} hours`}</span>
                                    </TableCell>
                                    <TableCell className="table-cell right" style={{ maxWidth: "50px" }} />
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>}
                    </>
                  </ExpandableComponent>
                  <div className="job-details-wrapper">
                    <ExpandableComponent
                      title={t('moreDetails').toUpperCase()}
                      subtitle={""}
                      defaultExpanded={false}
                    >
                      <div className="job-details">
                        <div className="job-details-left">
                          <h2 className="sub-title">{t('responsibilities').toUpperCase()}</h2>
                          <div className="table-content">
                            <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                              <Table sx={{ width: "max-content", border: 'none' }}>
                                <TableBody className="tablebody">
                                  {slicedResponsibilitiesData?.map((row, index) => (
                                    <TableRow
                                      key={row?.resp_code_xx}
                                      className={`${selectedResponsibility?.resp_code_xx === row?.resp_code_xx ? "tablerow current" : "tablerow"}`}
                                      onClick={() => setSelectedResponsibility(row)}
                                    >
                                      <TableCell className="table-cell center" style={{ maxWidth: "40px" }}>
                                        {responsibilitiesPage * rowsPerPage + index + 1}
                                      </TableCell>
                                      <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                                        <span className="sub-title">{row?.resp_code_xx}</span>
                                      </TableCell>
                                      <TableCell className="table-cell left" style={{ width: "auto" }}>
                                        <span className="sub-title">{row?.resp_text_xx}</span>
                                      </TableCell>
                                      <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                        <span style={{ width: "10px" }} />
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                              {jobResponsibilities.length > rowsPerPageResponsibilities &&
                                <TablePagination
                                  rowsPerPageOptions={[5]}
                                  rowsPerPage={rowsPerPageResponsibilities}
                                  onRowsPerPageChange={handleResponsibilitiesChangeRowsPerPage}
                                  component="div"
                                  count={jobResponsibilities.length}
                                  page={responsibilitiesPage}
                                  onPageChange={handleResponsibilitiesChangePage}
                                />}
                            </TableContainer>
                          </div>
                        </div>
                        <hr className="separator-v" />
                        <div className="job-details-right">
                          <h2 className="sub-title">{t('qualifications').toUpperCase()}</h2>
                          <div className="table-content">
                            <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                              <Table sx={{ width: "max-content", border: 'none' }}>
                                <TableBody className="tablebody">
                                  {slicedQualificationsData?.map((row, index) => (
                                    <TableRow
                                      key={row?.qual_code_xx}
                                      className={`${selectedQualification?.qual_code_xx === row?.qual_code_xx ? "tablerow current" : "tablerow"}`}
                                      onClick={() => setSelectedQualification(row)}
                                    >
                                      <TableCell className="table-cell center" style={{ maxWidth: "40px" }}>
                                        {qualificationsPage * rowsPerPage + index + 1}
                                      </TableCell>
                                      <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                                        <span className="sub-title">{row?.qual_code_xx}</span>
                                      </TableCell>
                                      <TableCell className="table-cell left" style={{ width: "auto" }}>
                                        <span className="sub-title">{row?.qual_text_xx}</span>
                                      </TableCell>
                                      <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                        <span style={{ width: "10px" }} />
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                              {jobQualifications.length > rowsPerPageQualifications &&
                                <TablePagination
                                  rowsPerPageOptions={[5]}
                                  rowsPerPage={rowsPerPageQualifications}
                                  onRowsPerPageChange={handleQualificationsChangeRowsPerPage}
                                  component="div"
                                  count={jobQualifications.length}
                                  page={qualificationsPage}
                                  onPageChange={handleQualificationsChangePage}
                                />}
                            </TableContainer>
                          </div>
                        </div>
                      </div>
                    </ExpandableComponent>
                  </div>
                </div>}
              {currentView === "hierachy" &&
                <div className="position-hierachy">
                  <BimaOrgChart hierarchy={orgHierarchy} />
                </div>}
            </div>
          </div>
          <div className="hr-position-right-wrapper" style={{ display: currentView === "position" ? "flex" : "none" }}>
            <div className="search-input-wrapper" style={{ width: "95%" }}>
              <FiSearch className="search-input-icon" />
              <input
                className="search-input"
                type="text"
                placeholder={`${t('search')} ${positions?.length === 1 ? `${positions?.length} ${t('position')}` : `${positions?.length} ${t('positions')}`}`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {searchTerm.length > 0 && (
                <CloseIcon
                  onClick={() => {
                    try {
                      setSearchTerm("");
                      setCurrentPage(0);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                  className="search-input-icon"
                />
              )}
            </div>
            <div className="options-list">
              {filteredPositions?.map((position) => (
                <>
                  <span
                    key={position._id}
                    className={`${selectedPosition._id === position?._id
                      ? "single-option active"
                      : "single-option"
                      }`}
                    onClick={async () => {
                      try {
                        setSearchLeaveTypes("");
                        setCurrentView("position");
                        setSelectedPosition(position);
                        const formattedStructure = position?.salary_structure?.map(row => ({
                          ...row,
                          min_salary: numeral(row?.min_salary).format("0,0.00"),
                          max_salary: numeral(row?.max_salary).format("0,0.00"),
                        }));
                        setSalaryStucture(formattedStructure);
                        setSelectedQualification(null);
                        setSelectedResponsibility(null);
                        setSelectedLeaveType(null);
                        setCurrentPage(0);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  >
                    <div className="title-row">
                      <span className="cy-title">{position?.pos_title}</span>
                    </div>
                  </span>
                  <hr className="separator-h" />
                </>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton onClick={() => setIsNotifyDialogOpen(false)}> {t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle={t('confirmation')}
        dialogContent={<p dangerouslySetInnerHTML={{ __html: objectToAction?.action_text }} />}
      />
      {isPositionDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('newPosition')}</h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => {
                  try {
                    resetAction();
                    setIsPositionDialogOpen(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <div className="input-item-with-label">
                <label htmlFor="position_code" style={{ width: "100px" }}>
                  {t('code').toUpperCase()}
                </label>
                <input
                  name="position_code"
                  type="text"
                  placeholder={t('code').toUpperCase()}
                  className="form-input-item"
                  style={{ width: "200px" }}
                  value={positionCode}
                  onChange={(e) => setPositionCode(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                <label htmlFor="position_title" style={{ width: "100px" }}>
                  {t('title').toUpperCase()}
                </label>
                <input
                  name="position_title"
                  type="text"
                  placeholder={t('title').toUpperCase()}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  value={positionTitle}
                  onChange={(e) => setPositionTitle(e.target.value)}
                />
              </div>
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                iconPosition="end"
                currentTheme={currentTheme}
                borderRadiusType="right"
                onClick={async () => {
                  try {
                    if (!positionCode) {
                      setNotifyDialogTitle("Note!");
                      setNotifyDialogText(`Please enter code!`);
                      setIsNotifyDialogOpen(true);
                      return;
                    }

                    if (!positionTitle) {
                      setNotifyDialogTitle("Note!");
                      setNotifyDialogText(`Please enter title!`);
                      setIsNotifyDialogOpen(true);
                      return;
                    }

                    const res = await newRequest.post(
                      "/hrPosition/add",
                      {
                        pos_code: positionCode,
                        pos_title: positionTitle
                      }
                    );
                    if (res.data?.msg === "added") {
                      setPositions((prevData) => {
                        const updated = [...prevData, res.data?.doc];
                        return updated.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
                      });
                      setIsPositionDialogOpen(false);
                      setSelectedPosition(res.data?.doc);
                      showToast(`${positionTitle} added!`, "success");
                      resetAction();
                      if (jobRef.current) {
                        jobRef.current.focus();
                      }
                    } else if (res.data?.msg === "exists") {
                      showToast(t('positionCodeExists', { param1: positionCode }), "error");
                    } else {
                      showToast(res.data?.msg, "error");
                    }
                  } catch (error) {
                    console.log(error);
                  }
                }}>
                {t('add').toUpperCase()}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}

      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default HrPosition;
